export default {
  welcomeBack: 'Welcome Back',
  loginToYourAccount: 'Login to your account',
  dontHaveAnAccountYet: "Don't have an account Yet?",
  createAccount: 'Create Account',
};
